/** Names a job (or one revision of it) inside its organization, e.g. "org1/job1". */
export const scopedIdentity = (
  organizationId: string | undefined,
  identity: string,
) => `${organizationId ?? ''}/${identity}`;

/**
 * Lets a request that finishes late tell whether its result still belongs on the page: the
 * editor that sent it must still be open, on the same job or revision. Open it while the page
 * shows `identity`, close it when the page goes away.
 */
export class MutationScope {
  private identity = '';
  private open = false;

  /** What the page shows now, e.g. "org1/job1/hash3". */
  setIdentity(identity: string) {
    this.identity = identity;
  }

  activate() {
    this.open = true;
  }

  deactivate() {
    this.open = false;
  }

  /**
   * Call when a request starts. The check it returns stays true while the scope is open and
   * still on `started` (by default what it shows now).
   */
  begin(started = this.identity) {
    return () => this.open && this.identity === started;
  }
}
